import type { RouteRecord } from 'vite-react-ssg';
import App from './App';

/**
 * Route tree consumed by vite-react-ssg.
 *
 * URL scheme:
 *  - `/`               → Spanish home (default locale, clean URL)
 *  - `/faq`            → FAQ (Spanish)
 *  - `/privacidad`     → Privacy policy (Spanish)
 *  - `/cookies`        → Cookie policy (Spanish)
 *  - `/aviso-legal`    → Legal notice (Spanish)
 *  - `/en`             → English home
 *  - `/en/faq`         → FAQ (English)
 *  - `/en/privacy`     → Privacy policy (English)
 *  - `/en/cookies`     → Cookie policy (English)
 *  - `/en/legal`       → Legal notice (English)
 *
 * Each route is a distinct prerendered HTML file — critical for Google
 * Sitelinks (Google won't show sitelinks for anchor-only sections).
 */
export const routes: RouteRecord[] = [
  {
    path: '/',
    Component: App,
    entry: 'src/App.tsx',
    children: [
      // === Spanish (default) ===
      { index: true, lazy: () => import('./pages/Home') },
      { path: 'faq', lazy: () => import('./pages/Faq') },
      { path: 'privacidad', lazy: () => import('./pages/Privacy') },
      { path: 'cookies', lazy: () => import('./pages/CookiePolicy') },
      { path: 'aviso-legal', lazy: () => import('./pages/LegalNotice') },
      { path: 'bonos', lazy: () => import('./pages/Bonos') },

      // === English ===
      { path: 'en', lazy: () => import('./pages/Home') },
      { path: 'en/faq', lazy: () => import('./pages/Faq') },
      { path: 'en/privacy', lazy: () => import('./pages/Privacy') },
      { path: 'en/cookies', lazy: () => import('./pages/CookiePolicy') },
      { path: 'en/legal', lazy: () => import('./pages/LegalNotice') },
      { path: 'en/bonos', lazy: () => import('./pages/Bonos') },
    ],
  },
];

export default routes;
